import { EShopCategory } from '@r1-frontend/api-domru/api-content/v1/shop/items/dto/RequestDto';

import { IAddress } from '@r1-frontend/shared/types/IAddress';

import { EDeliveryMethod } from '~/src/features/domofon/purchase/types/EDeliveryMethod';
import { EEquipmentType } from '~/src/features/domofon/purchase/types/EEquipmentType';
import { EPaymentMethod } from '~/src/features/domofon/purchase/types/EPaymentMethod';
import { EStages } from '~/src/features/domofon/purchase/types/EStages';
import { TDeliveryMethodOptions } from '~/src/features/domofon/purchase/types/TDeliveryMethodOptions';
import TEquipment from '~/src/features/domofon/purchase/types/TEquipment';
import { RussianPostResponseType } from '~/src/thirdPartyServices/pochta/types/ResponseType';

/**
 * @param _totalSelected общее кол-во выбранного оборудования, используется для выбора текущего шага (скрытие/показ секций)
 */
export type InitialState = {
    initialized: boolean,
    oneItemPurchaseType?: EEquipmentType | null,
    _category: EShopCategory | null,
    equipments: Record<number, TEquipment>,
    _totalSelected: number,
    address: IAddress | null,

    person: string,
    phone?: string | number,

    isContactDetailsConfirmed: boolean,
    availableServicesByAddress: [],

    deliveryMethod: EDeliveryMethod,
    deliveryMethodOptions: Record<EDeliveryMethod, TDeliveryMethodOptions[]> | null,

    isDeliveryAddressSelection: boolean,
    selectedDeliveryAddress: RussianPostResponseType | null,
    addressVerificationState: AddressVerificationState,

    selectedDeliveryMethodOptions: number | null,

    paymentMethod: EPaymentMethod | null,

    stage: EStages,

    isOrderBeingProcessed: boolean,
    isOrderCreated: boolean | null,
    createdOrderId?: number,
};

export enum AddressVerificationState {
    notVerified = 'not verified',
    verifying = 'verifying',
    verified = 'verified',
}


const initialState: InitialState = {
    initialized: false,
    _category: null,

    oneItemPurchaseType: null,
    equipments: {},
    _totalSelected: 0,
    address: null,
    person: '',

    isContactDetailsConfirmed: false,
    addressVerificationState: AddressVerificationState.notVerified,
    availableServicesByAddress: [],

    deliveryMethodOptions: null,
    deliveryMethod: EDeliveryMethod.PICKUP_POINT,
    selectedDeliveryMethodOptions: null,

    isDeliveryAddressSelection: false,
    selectedDeliveryAddress: null,

    paymentMethod: null,

    stage: EStages.Select,

    isOrderBeingProcessed: false,
    isOrderCreated: null,
};

export default initialState;
